import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Payement, PaymentGroup } from "@/savaradio/common";

export const initialLoading = {
  create: false,
  delete: false,
  update: false,
  get: false,
  find: false
}
export type IsLoading = Record<keyof typeof initialLoading, boolean>


const initialState: { value?: PaymentGroup[], isLoading: IsLoading } = { isLoading: initialLoading }

const payementSlice = createSlice({
  name: "payement_slice",
  initialState,
  reducers: {
    append: (state, action: PayloadAction<Payement>) => {
      if (!state.value) state.value = [{
        _id: action.payload.client!,
        count: 1,
        payements: [action.payload]
      }]
      else {
        const target_payement_group = state.value.find(payement_group => payement_group._id === action.payload.client)
        if (
          target_payement_group &&
          !target_payement_group.payements.some(item => item._id === action.payload._id)
        ) {
          state.value = state.value.map(payement_group => {
            if (payement_group._id === target_payement_group._id) return {
              ...target_payement_group,
              count: target_payement_group.count + 1,
              payements: [...target_payement_group.payements, action.payload]
            }
            else return payement_group
          })
        }
        if (!target_payement_group) {
          state.value = [
            ...state.value,
            {
              _id: action.payload.client!,
              count: 1,
              payements: [action.payload]
            }
          ]
        }
      }
    },
    pop: (state, action: PayloadAction<Payement>) => {
      if (state.value) {
        const target_payement_group = state.value.find(payement_group => payement_group._id === action.payload.client)
        if (target_payement_group) {
          state.value = state.value.map(payement_group => {
            if (payement_group._id === target_payement_group._id) return {
              ...target_payement_group,
              count: target_payement_group.count - 1,
              payements: target_payement_group.payements.filter(payement => payement._id !== action.payload._id)
            }
            return payement_group
          })
        }
      }
    },
    merge: (state, action: PayloadAction<Payement>) => {
      if (state.value) {
        const target_payement_group = state.value.find(payement_group => payement_group._id === action.payload.client)
        if (target_payement_group) {
          state.value = state.value.map(payement_group => {
            if (payement_group._id === target_payement_group._id) return {
              ...target_payement_group,
              payements: target_payement_group.payements.map(payement => payement._id === action.payload._id ? action.payload : payement)
            }
            return payement_group
          })
        }
        else {
          state.value = state.value.map(payement_group => ({
            ...payement_group,
            payements: payement_group.payements.filter(payement => payement._id !== action.payload._id)
          })).concat([{
            _id: action.payload.client!,
            count: 1,
            payements: [action.payload]
          }])
        }
      }
    },
    reset: (state, action: PayloadAction<PaymentGroup[] | undefined>) => {
      state.value = action.payload
    },
    setLoading: (state, action: PayloadAction<Partial<IsLoading>>) => {
      state.isLoading = {
        ...state.isLoading,
        ...action.payload
      }
    }
  }
})

export const { append, pop, merge, reset, setLoading } = payementSlice.actions

export const payement_slice = payementSlice.reducer